import { Tabs as TabsPrimitive } from '@base-ui/react/tabs'
import type { ReactNode } from 'react'

/**
 * Tabs for the detail pages.
 *
 * @betstarters/ui ships no Tabs component, so these wrap the same primitive
 * layer the kit itself is built on (@base-ui/react) with the kit's tokens —
 * rather than hand-rolling buttons and conditional rendering.
 */

export const Tabs = TabsPrimitive.Root
export const TabsPanel = TabsPrimitive.Panel

export function TabsList({ children }: { children: ReactNode }) {
  return <TabsPrimitive.List className="mb-6 flex gap-1 border-b">{children}</TabsPrimitive.List>
}

export function Tab({ value, children }: { value: string; children: ReactNode }) {
  return (
    <TabsPrimitive.Tab
      value={value}
      className="-mb-px cursor-pointer border-b-2 border-transparent px-3 py-2 text-sm font-medium text-muted-foreground transition-colors outline-none hover:text-foreground focus-visible:ring-3 focus-visible:ring-ring/50 data-[selected]:border-primary data-[selected]:text-foreground"
    >
      {children}
    </TabsPrimitive.Tab>
  )
}

/** TabCount renders the "(244)" a tab label carries. */
export function TabCount({ value }: { value: number }) {
  return <span className="ml-1.5 text-xs font-normal text-muted-foreground">({value})</span>
}
